import { showWizardModel } from "../../../wizards/RTLWizard";
import NewLeadWizardModel, { NewLeadWizardData } from "../../../wizards/NewLeadWizard";
import { queryNoTracking } from "../../../services/DataService";

const query_NewLead_LoadContact = queryNoTracking("NewLead_LoadContact");

export async function OpenNewLeadForChat({ contactID, contactPoint, contactName }) {
    // Case A: chat already linked to a Contact → hydrate from server
    if (contactID) {
        const details = await query_NewLead_LoadContact.getFirstOrDefault({ contactID });
        const data = new NewLeadWizardData({});
        data.setBillingContact(details.BillingContact);
        data.setJobContact(details.JobContact);
        if (details.Company) data.setBillingCompany(details.Company);
        data.SiteContactSelection = 2;
        await showWizardModel(new NewLeadWizardModel({ data, defaultPageIndex: 1 }), true);
        return;
    }

    // Case B: no linked Contact → start fresh, prefill phone/name from chat
    const data = new NewLeadWizardData({});
    if (contactPoint) data.BillingContact.Mobile = contactPoint;
    if (contactName) {
        const parts = String(contactName).trim().split(/\s+/);
        data.BillingContact.FirstName = parts.shift() || "";
        data.BillingContact.LastName = parts.join(" ");
    }
    await showWizardModel(new NewLeadWizardModel({ data, defaultPageIndex: 1 }), true);
}
